import React from 'react';

import { StateLabel } from '@common/components';
import { WorksTimekeepingWorkerTimesheetStatus } from '@common/graphql/schema';

const WORKER_TIMESHEET_COLOR_STYLE_MAP: Record<string, string> = {
  submitted: 'sky-regular',
  approved: 'grass',
  overdue: 'coral',
  rejected: 'coral',
} as const;

export const WORKER_TIMESHEET_LABEL_OVERWRITE = {
  not_submitted: 'Not Submitted',
  submitted: 'Submitted',
  approved: 'Approved',
  overdue: 'Overdue',
  rejected: 'Rejected',
  processing: 'Processing',
  invoiced: 'Invoiced',
  expired: 'Expired',
} satisfies Record<WorksTimekeepingWorkerTimesheetStatus, string>;

export const WorkerTimesheetStatus = ({
  status,
}: {
  status: WorksTimekeepingWorkerTimesheetStatus;
}) => (
  <StateLabel
    state={WORKER_TIMESHEET_LABEL_OVERWRITE[status] || status}
    color={WORKER_TIMESHEET_COLOR_STYLE_MAP[status]}
  />
);
